
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"14"}},[_c('path',{attrs:{"fill":"currentColor","d":"M10.444 4.563L6 8.938 1.556 4.561l.788-.776 3.1 3.057V.188h1.112v6.655L9.66 3.791l.783.772zM10 9.155h1.333v3.938H.667V9.156H2v2.625h8V9.156z"}})])
      }
    
      }
    